import { getScoreLetterFromKgeCO2PerParticipant } from '@/domain/impact-calculate/utils/get-score-letter-from-co2-per-participant';
import { CalculateFestival } from '@/domain/impact-calculate-festival/entities/calculate-festival.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { RootState } from '@/domain/store';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { computeKgCo2ByParticipantFestival } from './utils/compute-kg-co2-by-participant-festival';

type Result = { projectId: number; calculate: CalculateFestival }[];

export const getAllImpactCalculateForAllProjects = createAppAsyncThunk(
  'impactCalculate/getAllImpactCalculateForAllProjects',
  async (
    _,
    { extra: { impactCalculateFestivalGateway, snackbarGateway }, getState },
  ): Promise<Result> => {
    try {
      let result =
        await impactCalculateFestivalGateway.getAllImpactCalculateFestivalForAllProjects();
      result = result.map((x) => treatCo2ScoreLetter(x, getState()));
      return result;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactCalculate.Message.error'));
}

function treatCo2ScoreLetter(
  item: {
    projectId: number;
    calculate: CalculateFestival;
  },
  state: RootState,
): { projectId: number; calculate: CalculateFestival } {
  if (!item.calculate.co2) {
    return item;
  }
  const kgeCO2ByParticipant = computeKgCo2ByParticipantFestival(
    state,
    item.calculate.co2,
    item.projectId,
  );
  const scoreLetter = getScoreLetterFromKgeCO2PerParticipant(
    kgeCO2ByParticipant,
    'festival',
  );
  const newItem = {
    ...item,
    calculate: {
      ...item.calculate,
      co2: {
        ...item.calculate.co2,
        scoreLetter,
        kgeCO2ByParticipant,
      },
    },
  };

  return newItem;
}
